<template>
    <div>
        <card-component class="p-3" title="Escolha a data de importação" button-icon="fa-gear">
            <template v-slot:content>
                <div class="row mt-1">
                    <div class="col-6">
                        <div class="d-flex gap-2">
                            <input class="form-control" type="date" name="date" id="date" value="" v-model="date" @change="errors.date = ''">
                            <button type="button" class="btn btn-primary" @click="getDatas">
                                <font-awesome-icon icon="fa-solid fa-magnifying-glass"/>
                            </button>
                        </div>
                        <alert-error-message-component class="p-1" v-if="errors.date" :mesage="errors.date">
                        </alert-error-message-component>
                    </div>
                </div>

            </template>
        </card-component>


        <div class="mt-2">

            <div v-if="isLoader" class="d-flex justify-content-center">
                <loader-component class=""></loader-component>
            </div>

            <card-component :footer="false" v-if="!isLoader">
                <template v-slot:content>
                    <table-component
                        :data="datas.data"
                        :show="{visible : false, target : 'self'}"
                        :update="{visible : false, target : 'self'}"
                        :remove="{visible : true, target: 'modal', dataBsTarget: '#removeModal'}"
                        :column="{
                            id : {title : 'ID', type : 'integer', class : 'd-none'},
                            date : { title : 'DATA', type : 'date', class: 'flex-wrap' },
                            principal1 : { title : 'PRINCIPAL 1', type : 'string', class: '' },
                            ovo : { title : 'OVO/ OMELETE', type : 'string', class: 'd-none d-md-table-cell' },
                            main_light : { title : 'PRINCIPAL LIGHT', type : 'string', class: 'd-none d-md-table-cell' },
                            chef_dish : { title : 'PRATO FO CHEF', type : 'string', class: 'd-none d-md-table-cell' },
                            // fit_grill : { title : 'FIT GRILL', type : 'string', class: 'd-none d-md-table-cell' },
                            // fit_grill_opcao1 : { title : 'FIT GRILL OPC 1', type : 'string', class: 'd-none d-md-table-cell' },
                            // fit_grill_opcao2 : { title : 'FIT GRILL OPC 2', type : 'string', class: 'd-none d-md-table-cell' },
                       }"
                    ></table-component>
                </template>

                <template v-slot:footer>

                </template>

            </card-component>
        </div>

        <confirm-modal-component
            modalId="removeModal"
            modalTitle="Remover Refeição"
            :modalBody="'Você deseja mesmo remover esta refeição de '+ this.formateDateBR(this.$store.state.item.date)"
            buttonText="Remover"
            :btnAction="removeData"
        >

        </confirm-modal-component>

    </div>


</template>

<script>
export default {
    name: "CustomerEmployeesManager",
    props: ['apiUrl', 'apiUrlDelete'],
    data() {
        return {
            date: '',
            isLoader: false,
            datas: { data: [] },
            errors : { 'date' : '' }
        }
    },
    methods: {
        formValidationdation() {
            if(this.date === '') {
                this.errors.date = 'Informe a data de importação ';
                return false;
            }
            return true;
        },
        getDatas() {
            this.errors.date = '';
            if(!this.formValidationdation()) {
                this.isLoader = false;
                return;
            }
            let url = this.apiUrl + '/' + this.date;
            this.isLoader = true;
            axios.get(url)
                .then(response => {
                    this.datas.data = response.data;
                    this.isLoader = false;
                })
                .catch(error => {
                    this.isLoader = false;
                    console.log(error);
                });
        },

        removeData(){
            let url = this.apiUrlDelete + '/' + this.$store.state.item.id;

            let formData = new FormData();
            formData.append('_method', 'DELETE');

            axios.post(url, formData)
                .then(response => {
                    console.log(response.data);
                    if(response.data.status === true) {
                        this.$store.state.transaction.status = 'success';
                        this.$store.state.transaction.mmessage =  response.data.message;
                        this.getDatas();
                    }else{
                        this.$store.state.transaction.status = 'error';
                        this.$store.state.transaction.mmessage = response.data.message;
                        this.$store.state.transaction.data = response.data.data;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$store.state.transaction.status = 'error';
                    this.$store.state.transaction.mmessage = 'Erro ao remover refeição.';
                    this.$store.state.transaction.data = error.response.data;
                });

        }
    }

}

</script>

<style scoped>

</style>
